function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M9 7V2a1 1 0 00-2 0v5H2a1 1 0 000 2h5v5a1 1 0 102 0V9h5a1 1 0 100-2H9z"
});

function SvgPlus16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTkgN1YyQzkgMS40NDc3MiA4LjU1MjI4IDEgOCAxQzcuNDQ3NzIgMSA3IDEuNDQ3NzIgNyAyVjdIMkMxLjQ0NzcyIDcgMSA3LjQ0NzcyIDEgOEMxIDguNTUyMjggMS40NDc3MiA5IDIgOUg3VjE0QzcgMTQuNTUyMyA3LjQ0NzcyIDE1IDggMTVDOC41NTIyOCAxNSA5IDE0LjU1MjMgOSAxNFY5SDE0QzE0LjU1MjMgOSAxNSA4LjU1MjI4IDE1IDhDMTUgNy40NDc3MiAxNC41NTIzIDcgMTQgN0g5WiIgLz4KPC9zdmc+Cg==";
export { SvgPlus16 as ReactComponent };